import {HttpClient} from '@angular/common/http';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteModule} from '@angular/material/autocomplete';
import {fuseAnimations} from '@fuse/animations/public-api';
import {debounceTime, filter, map, Subject, takeUntil} from 'rxjs';
import {NahausMessagesModularService} from '../../../modules/admin/outbox/services/nahausMessages-modular.service';
import {Router, RouterLink} from '@angular/router';
import {ContactNamePipe} from '../../../shared/pipes/contact-name.pipe';
import {MatOptionModule} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet} from '@angular/common';

@Component({
    selector: 'search-old',
    templateUrl: './search.component.html',
    encapsulation: ViewEncapsulation.None,
    exportAs: 'fuseSearch',
    animations: fuseAnimations,
    standalone: true,
    imports: [NgIf, MatButtonModule, MatIconModule, NgSwitch, NgSwitchCase, NgFor, MatFormFieldModule, MatInputModule, FormsModule, MatAutocompleteModule, ReactiveFormsModule, MatOptionModule, RouterLink, NgTemplateOutlet, NgClass, ContactNamePipe]
})
export class SearchComponent implements OnChanges, OnInit, OnDestroy {
    @Input() appearance: 'basic' | 'bar' = 'basic';
    @Input() debounce: number = 300;
    @Input() minLength: number = 2;
    @Output() search: EventEmitter<any> = new EventEmitter<any>();
    opened: boolean = false;
    resultSets: any[];
    searchControl: UntypedFormControl = new UntypedFormControl();
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _elementRef: ElementRef,
        private _httpClient: HttpClient,
        private _renderer2: Renderer2,
        private nahausMessagesModularService: NahausMessagesModularService,
        private router: Router
    ) {
        // this.config = {
        //     indexName: environment.algolia.indexName.properties,
        //     searchClient: this.nahausMessagesModularService?.authService?.getAlgoliaSearchClient(false),
        //     routing: true
        // };
    }

    private _matAutocomplete: MatAutocomplete;

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter for mat-autocomplete element reference
     *
     * @param value
     */
    @ViewChild('matAutocomplete')
    set matAutocomplete(value: MatAutocomplete) {
        this._matAutocomplete = value;
    }

    /**
     * Host binding for component classes
     */
    @HostBinding('class') get classList(): any {
        return {
            'search-appearance-bar': this.appearance === 'bar',
            'search-appearance-basic': this.appearance === 'basic',
            'search-opened': this.opened
        };
    }

    /**
     * Setter for bar search input
     *
     * @param value
     */
    @ViewChild('barSearchInput')
    set barSearchInput(value: ElementRef) {
        // If the value exists, it means that the search input
        // is now in the DOM, and we can focus on the input..
        if (value) {
            // Give Angular time to complete the change detection cycle
            setTimeout(() => {

                // Focus to the input element
                value.nativeElement.focus();
            });
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        // Appearance
        if ('appearance' in changes) {
            // To prevent any issues, close the
            // search after changing the appearance
            this.close();
        }
    }
    onQuerySuggestionClick(result: any){
      console.log('the result is' , result.indexName)
      console.log('the result is' , result.value)
      const indexName = result.indexName
      const value = result.value
      if(indexName === 'cards'){
        console.log('we are here in cards')
        this.router.navigate([`/ticketing/${value?.boardId}/card/${value?.id}`]);
      }
      if(indexName === 'properties'){
        console.log('we are here in properties')
        this.router.navigate([`/immobilien/${value?.id}/units/allgemein`]);
      }
      if(indexName === 'units'){
        console.log('we are here in properties')
        this.router.navigate([`/immobilien/${value?.propertyID}/einheit/${value?.id}/mieter`]);
      }
      if(indexName === 'tenants'){
        console.log('we are here in tenants')
        this.router.navigate([`/mietersuche/${value?.id}`]);
      }
      if(indexName === 'contacts'){
        console.log('we are here in contacts')
        this.router.navigate([`/kontakte/${value?.id}`]);
      }
      if(indexName === 'landlords'){
        console.log('we are here in landlords')
      this.router.navigate([`/eigentuemer/${value?.id}`]);
      }
      if(indexName === 'managers'){
        console.log('we are here in managers')
      this.router.navigate([`/verwalter/${value?.id}`]);
      }
      if(indexName === 'msa'){
        console.log('we are here in managers')
      this.router.navigate([`/mieterselbstauskunft/alle/${value?.id}`]);
      }
      if(indexName === 'files'){
        console.log('we are here in managers')
        this.router.navigate([`/files/details/${value?.id}`]);
      }
        this.close()

    }
    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the search field value changes
        this.searchControl.valueChanges
            .pipe(
                debounceTime(this.debounce),
                takeUntil(this._unsubscribeAll),
                map((value) => {

                    // Set the resultSets to null if there is no value or
                    // the length of the value is smaller than the minLength
                    // so the autocomplete panel can be closed
                    if (!value || value.length < this.minLength) {
                        this.resultSets = null;
                    }

                    // Continue
                    return value;
                }),
                // Filter out undefined/null/false statements and also
                // filter out the values that are smaller than minLength
                filter(value => value && value.length >= this.minLength)
            )
            .subscribe((value) => {
                this._httpClient.post('api/common/search', {query: value})
                    .subscribe((resultSets: any) => {

                        // Store the result sets
                        this.resultSets = resultSets;

                        // Execute the event
                        this.search.next(resultSets);
                    });
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On keydown of the search input
     *
     * @param event
     */
    onKeydown(event: KeyboardEvent): void {
        // Escape
        if (event.code === 'Escape') {
            // If the appearance is 'bar' and the mat-autocomplete is not open, close the search
            if (this.appearance === 'bar' && !this._matAutocomplete.isOpen) {
                this.close();
            }
        }
    }

    /**
     * Open the search
     * Used in 'bar'
     */
    open(): void {
        // Return if it's already opened
        if (this.opened) {
            return;
        }

        // Open the search
        this.opened = true;
    }

    /**
     * Close the search
     * * Used in 'bar'
     */
    close(): void {
        // Return if it's already closed
        if (!this.opened) {
            return;
        }

        // Clear the search input
        this.searchControl.setValue('');

        // Close the search
        this.opened = false;
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item?.id || index;
    }
}
